import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { Search as SearchIcon, Plus, Pencil } from 'components/icons'

type Props = IconProps

const Create: FC<Props> = (props) => {
  return <Plus {...props} />
}

const Search: FC<Props> = (props) => {
  return <SearchIcon {...props} />
}

const Update: FC<Props> = (props) => {
  return <Pencil {...props} />
}

const BasicExports = {
  Create,
  Search,
  Update,
}

export default BasicExports
